import Api from './../api'

export default DataLayer => DataLayer.$extend('auth', {
    login(data) {
        return Api.auth.login({}, data)
    },
})
